
export enum UserType {
    EMPLOYEE = -1,
    RESELLER = 0,
    ADMIN = 1,
}